import script from "./WorldMapSvg.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorldMapSvg.vue?vue&type=script&setup=true&lang=ts"

import "./WorldMapSvg.vue?vue&type=style&index=0&id=e2a8b3fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2a8b3fc"]])

export default __exports__